import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faGithub,
  faGitlab,
} from "@fortawesome/free-brands-svg-icons";
import LinkButton from "../Atoms/LinkButton";
import { gitHubLink, gitlabLink, linkedinLink } from "../../utils/link";
import { useTranslation } from "react-i18next";

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const { t } = useTranslation();

  return (
    <footer className="p-4 bottom-0 bg-white text-black dark:bg-gray-900 dark:text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between items-center">
          <div className="text-center md:text-left text-2xl font-bold mb-4 md:mb-0 ml-5 sm:ml-0">
            <h2>{t("footer.followMe")}</h2>
          </div>
          {/* <div className="flex flex-wrap justify-center md:justify-end space-x-4 mb-4  xs:mr-16 mr-0 md:mb-0"><div className="flex flex-wrap justify-center md:justify-end space-x-4 mb-4 mr-0 md:mr-16 md:mb-0"> */}
          <div className="flex flex-wrap justify-center md:justify-end space-x-4 mb-4 mr-0 md:mr-16 md:mb-0">
            <LinkButton href={gitlabLink} target="_blank">
              <FontAwesomeIcon
                icon={faGitlab}
                size="lg"
                className="hover:text-orange-500"
              />
            </LinkButton>
            <LinkButton href={linkedinLink} target="_blank">
              <FontAwesomeIcon
                icon={faLinkedin}
                size="lg"
                className="hover:text-blue-500"
              />
            </LinkButton>
            <LinkButton href={gitHubLink} target="_blank">
              <FontAwesomeIcon
                icon={faGithub}
                size="lg"
                className="hover:text-gray-500"
              />
            </LinkButton>
          </div>
        </div>
        <p className="text-center text-sm text-black dark:text-white mt-1">
          {t("footer.copyright")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
